export const IS_DEV = process.env.REACT_APP_ENV === 'dev';

export const IS_STANDALONE = window.matchMedia("(display-mode: standalone)")?.matches;